import { SButton } from '@setvi/shared/components';
import { CheckIconV2 } from '@setvi/shared/components/sicons';
import { Footer } from '../style';

interface ModalFooterProps {
  isLoading: boolean;
  onCancel: () => void;
  onSave: () => void;
}

export const ModalFooter = ({
  isLoading,
  onCancel,
  onSave
}: ModalFooterProps) => (
  <Footer>
    <SButton
      style={{ borderRadius: 120, minHeight: 40 }}
      variant="outlined"
      color="inherit"
      disabled={isLoading}
      onClick={onCancel}>
      Cancel
    </SButton>
    <SButton
      style={{ borderRadius: 120, minHeight: 40 }}
      variant="contained"
      loading={isLoading}
      disabled={isLoading}
      startIcon={<CheckIconV2 />}
      onClick={onSave}>
      Save Changes
    </SButton>
  </Footer>
);
